import { Container, Text } from './ComplexityTagStyles';

export interface ComplexityTagProps {
  complexity: 'beginner' | 'intermediate' | 'advanced';
}

const ComplexityTag = ({ complexity }: ComplexityTagProps) => (
  <Container
    $complexity={complexity}
    data-cy='crashCourseCardComplexity'
  >
    <Text $complexity={complexity}>{complexity.toUpperCase()}</Text>
  </Container>
);

export default ComplexityTag;
